// extracted by mini-css-extract-plugin
export default {"title":"_1x3YUgx5S6XJRTDMvgN9xO"};